const brandColors = {
    skyBlue: '#3970F6',
    skyBlueShade: '#2358DE',
    skyBlueLight: '#3693FF',
    midnightBlue: '#133075',
    midnightBlueShade: '#0B1E50',
    brightYellow: '#FFFF00'
};
const grayColors = {
    slate: '#2C2C2C',
    darkGray: '#808390',
    darkGrayShade: '#666872',
    mist: '#EAEAEA',
    white: '#FFFFFF'
};
const textColors = {
    textBlue: '#3693FF',
    sirenRed: '#D32F42',
    sirenRedShade: '#B21E2F',
    vividOrange: '#EF6244',
    vividOrangeShade: '#D44325'
};
const extraColors = {
    black: '#000000'
};
Object.assign(Object.assign(Object.assign(Object.assign({}, brandColors), grayColors), textColors), extraColors);

export { brandColors, extraColors, grayColors, textColors };
//# sourceMappingURL=colors.mjs.map
